export enum LoadingType {
    Default,
    Black,
    WhiteBox,
}